<template>
    <div class="home">
        <div class="banner">
          <img src="static/images/banner.png" />
        </div>
        <div class="title">
          {{ $t('home.title') }}
        </div>
        <div class="importgame" v-if="importgamearr.length>0">
            <div class="gameitem"  v-for="(item,index) in importgamearr" :keys="index" @click="gamedetail(item)">
              <img :src="item.icon" />
            </div>

        </div>
        <div class="importgame importgameload" v-else>
          <img class="load" src="static/images/load.gif" />
        </div>
        <div class="gameall">
          <div class="gamearritem" v-for="(item,index) in gamearr" :keys="index" @click="gameindex(item.href)">
            <img :src="item.url" />
            <p>{{item.name}}</p>
          </div>
          <i class="space"></i><i class="space"></i><i class="space"></i>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import {gamelist} from '@/api/index.js'
import Foot from '@/components/common/foot.vue'
import { mapGetters} from 'vuex'
export default {
  name: 'index',
  components:{Foot},
  data() {
     return {
        loginis:false,
        menuis:false,
        activeIndex:'index',
        username:'',
        importgamearr:[],
     }
  },
  computed: {
    ...mapGetters([
      'isGlobal'
    ]),
    gamearr() {
      if (this.isGlobal) {
        return [
          {name:'Dragonscapes Adventure',url:'static/images/Dragonscapes.png',href:'https://www.centurygames.com/games/dragonscapes-adventure/'},
          // {name:'Bingo Aloha',url:'static/images/BingoAloha.png',href:''},
          // {name:'Valor Legends Eternity',url:'static/images/ValorLegendsEternity.png',href:''},
          {name:'Idle Courier Tycoon',url:'static/images/IdleCourierTycoon.png',href:'https://www.centurygames.com/games/idle-courier-tycoon/'},
          {name:'Family Farm Seaside',url:'static/images/FamilyFarmSeaside.png',href:'https://www.centurygames.com/games/family-farm-seaside/'},
          {name:'Dream Detective',url:'static/images/DreamDetective.png',href:'https://www.centurygames.com/games/dream-detective/'},
          // {name:'Family Barn Tango',url:'static/images/FamilyBarnTango.png',href:'https://www.centurygames.com/games/dream-detective/'},
          // {name:'Shining Beyond',url:'static/images/shingbeyond.png',href:'https://www.centurygames.com/games/dream-detective/'},
        ]
      }
      return [
        {
          name:'飞龙岛历险记',
          url:'static/images/feilongdao-icon-150.png',
          href:'http://fldlxj.campfiregames.cn'
        },
        {
          name:'梦境侦探',
          url:'static/images/megnjing-icon-150.png',
          href:'https://mengjing.youdiangame.cn/'
        }
      ]
    }
  },
  created() {
  	var vm = this;
  	//获取session
  	if(window.location.href.indexOf('token=')>-1){
  		var session = window.location.href.split('?token=');
  		localStorage.setItem('cg-session',session[1])
  		setTimeout(function(){
  		   window.location.href = session[0];
  		},500)
  	}

  },
  mounted() {
   this.getlist()
  },
  methods:{
    //获取游戏列表
    getlist(){
      gamelist().then(res=>{
          //console.log(res.data);
          if(res.data.code == 1){
             this.importgamearr = res.data.data;
          }else{
            this.alertmsg(res.data.msg)
          }
      })
    },
    alertmsg(msg){
      alert(msg)
    },
    gamedetail(item){
      sessionStorage.setItem('detailsrc',item.icon)
      this.$router.push({name:'game',query: {game_id:item.game_id}});
      window.scrollTo(0,0)
    },
    gameindex(href){
      window.location.href = href;
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .banner img{
      display: block;
      width: 100%;
      height: auto;
    }
    .importgame{
      width: 100%;
    }
    .importgameload{
      height: 9.375rem;
    }
    .importgameload img{
      margin: 3.75rem auto;
    }
    .gameitem{
      width: calc(100% - 1.25rem);
      padding-left: 0.625rem;
      position: relative;
      margin-bottom: 0.625rem;
      cursor: pointer;
    }
    .gameitem img{
      width: 100%;
      height: auto;
    }
    .content{
      color: #FFFFFF;
      margin-left: 34%;
      margin-right: 2%;
      padding-top: 6%;
    }
    .content h4{
      font-size: 1.125rem;
      line-height: 20px;
      margin-bottom: 0.625rem;
    }
    .content p{
      font-size: 0.9375rem;
    }
    .gameall{
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      padding: 0 0.625rem;
    }
    .gameall .space{
      width: 21%;
      height: 1;
    }
    .gamearritem{
      width: 21%;
      cursor: pointer;
    }
    .gamearritem img{
      display: block;
      width: 100%;
    }
    .gamearritem p{
      height: 3.125rem;
      color: #FFFFFF;
      width: 100%;
      text-align: center;
      margin-top: 0.375rem;
      line-height: 1rem;
      font-size: 0.75rem;
    }

</style>



// WEBPACK FOOTER //
// src/components/index.vue